import { logResults } from '@lune/common/logger'
import { DEFAULT_CONFIG, NOBODY_LIST, api } from '../api/config'
import { unique } from '../utils'

export const buildTargets = async (): Promise<string[]> =>
  await api.fetch
    .single(DEFAULT_CONFIG)
    .then(logResults('config/list'))
    .then((result) => result.realms)
    .then((result) => result.map((r) => r.targets))
    .then((result) => result.flat())
    .then((result) => [...result, ...NOBODY_LIST])
    .then((result) => unique(result))
